/** Shared formatting and column helpers of the Гүйлгээний төлөвлөгөө module. */

export function sourceOptions(t) {
    return [
        { label: t("source.excel"), value: "EXCEL" },
        { label: t("source.manual"), value: "MANUAL" },
    ];
}

export function invoiceOptions(t) {
    return [
        { label: t("invoice.has"), value: "true" },
        { label: t("invoice.hasNot"), value: "false" },
    ];
}

export function getSourceLabel(value, t) {
    if (value === "EXCEL") return t ? t("source.excel") : "Excel";
    if (value === "MANUAL") return t ? t("source.manual") : "Гараар";
    return value || "-";
}

export function getSourceColor(value) {
    if (value === "EXCEL") return "geekblue";
    if (value === "MANUAL") return "green";
    return "default";
}

export function getPreviewStatusLabel(value, t) {
    if (value === "OK") return t("excel.status.ok");
    if (value === "DUPLICATE_IN_FILE") return t("excel.status.dupFile");
    if (value === "DUPLICATE_IN_DB") return t("excel.status.dupDb");
    if (value === "INVALID") return t("excel.status.invalid");
    return value || "-";
}

export function getPreviewStatusColor(value) {
    if (value === "OK") return "green";
    // Duplicates still import - amber marks them as a warning, not a blocker.
    if (value === "DUPLICATE_IN_FILE") return "orange";
    if (value === "DUPLICATE_IN_DB") return "gold";
    if (value === "INVALID") return "red";
    return "default";
}

export function formatPlanAmount(value) {
    if (value === null || value === undefined || value === "") return "-";

    const number = Number(value);
    if (!Number.isFinite(number)) return "-";

    return number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

export function formatPlanDate(value) {
    if (!value) return "-";
    return String(value).slice(0, 10);
}

export function formatPlanDateTime(value) {
    if (!value) return "-";
    return String(value).replace("T", " ").slice(0, 19);
}

export function formatFileSize(bytes) {
    if (!bytes && bytes !== 0) return "-";

    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}

/** Maps the Ant Design sorter object onto the backend sortField / sortOrder parameters. */
export function mapSorter(sorter) {
    const active = Array.isArray(sorter)
        ? sorter.find((item) => item?.order)
        : sorter;

    if (!active?.order) {
        return { sortField: undefined, sortOrder: undefined };
    }

    return {
        sortField: active.field || active.columnKey,
        sortOrder: active.order === "ascend" ? "asc" : "desc",
    };
}

/** Turns the shared form values into the API payload used by create and update. */
export function buildTransactionPlanPayload(values) {
    return {
        sender: values.sender.trim(),
        beneficiary: values.beneficiary.trim(),
        beneficiaryBank: values.beneficiaryBank?.trim() || null,
        currency: values.currency,
        amount: values.amount,
        executionDate: values.executionDate.format("YYYY-MM-DD"),
    };
}
